<div class="ion-text-center">
  <ion-text color="primary">
    <h3 class="questions">{{ 'item-spot-list.¿Qué artefacto o ítem falla?' | translate }}</h3>
  </ion-text>
</div>

<ng-container *ngIf="!httpError">
  
  <ion-searchbar placeholder="{{ 'item-spot-list.Buscar'  | translate }}" type="text"
    debounce="300" (ionInput)="search($event)">
  </ion-searchbar>

  <cc-skeletons [type]="skeleton"></cc-skeletons>


  <div *ngIf="showLoader" class="ion-text-center">
    <ion-spinner name="lines"></ion-spinner>
  </div>


  <div *ngIf="itemsSpots.length">

    <ion-item *ngFor="let item of itemsSpots; let i = index" (click)="selectItemSpot(item)" class="ion-text-wrap"
      [disabled]="item.bloqueado"
      [ngClass]="{'selected-item': selectedItemId === item.id, 'last-item': i === itemsSpots.length - 1, 'item-bloqueado': item.bloqueado}">
      <ion-label class="ion-text-wrap">{{ item.item.item_nombre }} <span *ngIf="item.bloqueado">{{ 'item-spot-list.(Garantía vencida)' | translate }}</span>
        <p [ngClass]="{'selected-item': selectedItemId === item.id}">
          {{ item.lugar.lugar_nombre }}
        </p>
      </ion-label>
      <ion-icon *ngIf="selectedItemId === item.id" color="light" slot="end" name="checkmark"></ion-icon>
    </ion-item>



    <ion-infinite-scroll *ngIf="itemsSpots.length >= 20" threshold="500px" (ionInfinite)="loadMore($event)">
      <ion-infinite-scroll-content loadingSpinner="bubbles"
        loadingText="{{ 'item-spot-list.Cargando...'  | translate }}">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>

  <div *ngIf="!itemsSpots.length && !skeleton.show && !showLoader" class="centered-content">
    <ion-text large class="no-data" color="medium">
      <br>
      <h1>
        {{ 'item-spot-list.Sin resultados' | translate }}
      </h1>
    </ion-text>
  </div>
</ng-container>

<cc-http-error *ngIf="httpError" [errorMsg]="httpError" (retry)="ngOnInit()"></cc-http-error>

<div class="ion-padding-top ion-padding-bottom"></div>
